// @docs:
//   - docs/wip/CREW_PAPER_REQUESTS.md  § Skipper tracker, checks, downloads (Phase 3) — time zone (F2)
// ==============================================
// A request's emails go at 08:00 in its own time zone. Most accounts still
// have users.timezone = 'UTC' (nothing in the portal ever set it), which put
// 08:00 reminders at 8 pm in New Zealand — so the request form defaults to
// the browser's zone and lists the zones the browser knows.
// ==============================================

/** The browser's IANA zone ('Pacific/Auckland'), or UTC when it can't say. */
export function browserZone(): string {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'; } catch { return 'UTC'; }
}

/** A short list the skipper is likely to want, used when the browser can't list every zone. */
const COMMON = [
  'UTC', 'Pacific/Auckland', 'Pacific/Chatham', 'Pacific/Noumea', 'Pacific/Fiji', 'Pacific/Tongatapu', 'Pacific/Apia', 'Pacific/Rarotonga', 'Pacific/Tahiti', 'Pacific/Port_Vila',
  'Australia/Sydney', 'Australia/Brisbane', 'Australia/Hobart', 'Australia/Perth', 'Asia/Singapore', 'Europe/London', 'Europe/Paris', 'America/Los_Angeles', 'America/New_York',
];

/** Every zone the browser knows (sorted), always including the ones given (e.g. the request's own). */
export function zoneChoices(include: Array<string | null | undefined> = []): string[] {
  let all: string[] = COMMON;
  try {
    const listed = (Intl as unknown as { supportedValuesOf?: (k: string) => string[] }).supportedValuesOf?.('timeZone');
    if (listed?.length) all = ['UTC', ...listed];
  } catch { /* the short list will do */ }
  return [...new Set([...all, ...include.filter((z): z is string => !!z)])].sort((a, b) => (a === 'UTC' ? -1 : b === 'UTC' ? 1 : a.localeCompare(b)));
}
